import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="assembly-schematics"
export default class extends Controller {
  static values = { assemblies: Array }

  connect() {
    if (!window.location.hash) return

    this.element.addEventListener('load', () => {
      this.hideElements()
    })

    // If already loaded (cached)
    if (this.element.contentDocument) {
      this.hideElements()
    }
  }

  hideElements() {
    const svgDoc = this.element.contentDocument
    if (!svgDoc) return

    // Add CSS style to the SVG document
    const style = svgDoc.createElementNS('http://www.w3.org/2000/svg', 'style')
    style.textContent = '.hidden { display: none; }'

    const svgRoot = svgDoc.querySelector('svg')
    if (svgRoot) {
      svgRoot.insertBefore(style, svgRoot.firstChild)
    }

    const currentHash = window.location.hash.slice(1) // Remove the '#'

    const assembliesToHide = this.assembliesValue.filter(id => id !== currentHash)

    assembliesToHide.forEach(id => {
      const selector = `svg #assembly #${id}`
      svgDoc.querySelector(selector).classList.add("hidden")
    });
  }
}
